import Home from '../screens/Home';
import Other from '../screens/Other';
import NoMatch from '../screens/NoMatch';

import PATH from './route-path';
import InfoPay from 'src/screens/InfoPay';
import TypePay from 'src/screens/TypePay';
import ResultPay from 'src/screens/ResultPay';
import QrPay from 'src/screens/QrPay';

export const RoutesWithAuth = [
  {
    Component: Other,
    path: PATH.OTHER,
  },
  {
    Component: Home,
    path: PATH.HOME,
  },
  {
    Component: InfoPay,
    path: PATH.INFOPAY,
  },
  {
    Component: TypePay,
    path: PATH.TYPEPAY,
  },
  {
    Component: ResultPay,
    path: PATH.RESULTPAY,
  },
  {
    Component: QrPay,
    path: PATH.QRPAY,
  },
];

export const RoutesWithoutAuth = [
  {
    Component: NoMatch,
    path: PATH.NO_MATCH,
  },
];
